import { __generator } from "tslib";
import { call, all, takeLatest, put } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { request } from '../../xhr';
import { blockUser, unblockUser, blockUserSuccess, blockUserFail, unblockUserSuccess, unblockUserFail, blockUserAndDeleteChatroom, } from './actionCreators';
var logger = ddt.createLogger('usersaga');
function doBlockUser(userIdOrUuid, chatroomId) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/user/block',
                    data: {
                        userid: userIdOrUuid,
                        chatroom_id: chatroomId,
                    },
                }, function () { return ({ success: true }); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
function blockUserSaga(action) {
    var userIdOrUuid, result, userId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    logger.error('Tried to block invalid userId', action);
                    return [2 /*return*/];
                }
                userIdOrUuid = action.payload;
                return [4 /*yield*/, call(doBlockUser, userIdOrUuid)];
            case 1:
                result = _a.sent();
                userId = result && result.userid;
                if (!(result && result.success)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(blockUserSuccess(userId))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(blockUserFail(userId, result))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
function unblockUserSaga(action) {
    var userId, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    logger.error('Tried to unblock invalid userId', action);
                    return [2 /*return*/];
                }
                userId = action.payload;
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/user/unblock',
                        data: {
                            userid: userId,
                        },
                    }, function () { return ({ success: true }); })];
            case 1:
                result = _a.sent();
                if (!(result && result.success)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(unblockUserSuccess(userId))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(unblockUserFail(userId, result))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
function blockUserSagaAndDeleteChatroomSaga(action) {
    var result, userId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    logger.error('Tried to block invalid userId', action);
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(doBlockUser, action.payload.userId, action.payload.chatroomId)];
            case 1:
                result = _a.sent();
                userId = result && result.userid;
                if (!(result && result.success)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(blockUserSuccess(userId))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(blockUserFail(userId, result))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(blockUser, blockUserSaga),
                    takeLatest(unblockUser, unblockUserSaga),
                    takeLatest(blockUserAndDeleteChatroom, blockUserSagaAndDeleteChatroomSaga),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map